import {
  VALIDATION_ERROR_CODE,
  NOT_AUTHORIZED_CODE,
  INTERNAL_SERVICE_ERROR_CODE,
  ReservationAvailabilityError,
  ReservationValidationError,
  ReservationAuthorizationError,
  ServiceError
} from '../../model/errors';
import {useDefault, useFirst} from '../../../common/common';
import {ReservationErrorMapping} from '../../model/errors/reservation-error-mapping.model';
import {ReservationErrorCodes} from '../../model/errors/reservation-error-codes.model';
import {ServiceErrorMapper} from './service-error.mapper';

export class ReservationErrorMapper extends ServiceErrorMapper {
  map(error: any): ServiceError {
    const serviceError: ServiceError = super.map(error);
    const errorDetails = useDefault(error.error, {});
    if (serviceError.code === VALIDATION_ERROR_CODE) {
      const defaultValidationError = (serviceError instanceof ReservationValidationError) ? serviceError : new ReservationValidationError(errorDetails.code, ReservationErrorMapping.getMapping(errorDetails.code), serviceError.details);
      return this._mapCodeOrDefault(errorDetails.code, defaultValidationError);
    }
    if (serviceError.code === NOT_AUTHORIZED_CODE) {
      return this._mapCodeOrDefault(errorDetails.code, serviceError);
    }
    if (serviceError.code === INTERNAL_SERVICE_ERROR_CODE) {
      const customServiceError = useFirst(useDefault(errorDetails.errors, []), useFirst(errorDetails, {}));
      return this._mapCodeOrDefault(customServiceError.code, serviceError);
    }
    return serviceError;
  }

  private _mapCodeOrDefault(errorCode: string, defaultError: ServiceError): ServiceError  {
    const messageKey = ReservationErrorMapping.getMapping(errorCode);
    switch (errorCode) {
      /* CHECK THE AVAILABILITY OF GUESTS IN THE ROOM(S) */
      case ReservationErrorCodes.ERROR_052163: {
        return new ReservationAvailabilityError('errorGuests' + errorCode, messageKey, true);
      }
      /* CHECK THE AVAILABILITY OF THE RESERVATION ON THE SELECTED DATES */
      case ReservationErrorCodes.ERROR_052109:
      case ReservationErrorCodes.ERROR_052150:
      case ReservationErrorCodes.ERROR_052113:
      case ReservationErrorCodes.ERROR_052137:
      case ReservationErrorCodes.ERROR_058800: {
        return new  ReservationAvailabilityError('errorDates' + errorCode, messageKey, false, true);
      }
      case ReservationErrorCodes.ERROR_RESERVATION_5057:
      case ReservationErrorCodes.ERROR_GAPI_ROOM_AVAILABILITY:
      case ReservationErrorCodes.RESERVATION_5061:
      case ReservationErrorCodes.ERROR_052138: {
        return new ReservationAvailabilityError('errorRooms' + errorCode, messageKey, false, false, true);
      }
      /* We need to explicitly handle this because they are returned by multiple HTTP response codes*/
      case ReservationErrorCodes.ERROR_050535:
      case ReservationErrorCodes.ERROR__RESERVATION_4340:
      case ReservationErrorCodes.ERROR_RESERVATION_5070:
      case ReservationErrorCodes.NOT_AUTHORIZED: {
        return new ReservationAuthorizationError(errorCode, messageKey);
      }
      /* We need to explicitly handle this because it is returned by multiple HTTP response codes*/
      case ReservationErrorCodes.ERROR_052149: {
        return new ReservationValidationError(errorCode, messageKey);
      }
    }
    return defaultError;
  }
}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/mapper/reservation-error.mapper.ts